import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=f04cba22&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04cba22",
  null
  
)

export default component.exports